
<template>



 <!-- 租主才能使用 -->
	<section>
		
		
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form  :inline="true" :model="filters" style="float: right;" @submit.native.prevent>
			<!-- @keyup.enter.native="getMember" -->
			
				<el-form-item>
					<el-input  v-model="Telephone"  @keyup.enter.native="getMember" placeholder="号码"></el-input>
				</el-form-item>	
				<el-form-item>
					<el-input  v-model="CardNumber"  @keyup.enter.native="getMember" placeholder="卡号"></el-input>
				</el-form-item>			
			    <el-form-item>
                <el-select  v-model="shopId" clearable filterable placeholder="选择或搜索门店" @change="selectChange" >
                 <el-option
               v-for="item in Shopoptions"
               :key="item.Id"
                  :label="item.Name"
               :value="item.Id">
                  </el-option>
                   </el-select>				
                   </el-form-item>
				<el-form-item>
					<el-input  v-model="filters.Name"  @keyup.enter.native="getMember" placeholder="姓名"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button size="width:100%; height:100%;" type="primary" v-on:click="selectClick" icon="el-icon-search">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handBackups">备份当前</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="warning" @click="handBackupAll">备份所有</el-button>
				</el-form-item>	
				<el-form-item>
					<el-button type="primary" @click="DataCompensationClicik">业务补偿</el-button>
				</el-form-item>			
			</el-form>
		</el-col>

		<!--列表-->
		<el-table  :data="Members" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width:1702px">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column prop="ShopName" label="门店名称" width="180" sortable>
			</el-table-column>
			<el-table-column prop="CardNumber" label="卡号" width="120" sortable>
			</el-table-column>
			<el-table-column prop="Name" label="姓名" width="120" sortable>
			</el-table-column>
			<el-table-column prop="Sex" label="性别" width="100" :formatter="formatSex" sortable>
			</el-table-column>
			<el-table-column prop="Age" label="年龄" width="100" sortable>
			</el-table-column>
			<el-table-column prop="Telephone" label="电话" width="150" sortable>
			</el-table-column>
			<el-table-column prop="Birthday" label="生日" width="120" sortable :formatter="formatDate">
			</el-table-column>
			<el-table-column prop="IdNumber" label="身份证号码" width="190" sortable>
			</el-table-column>
			<el-table-column prop="CardType" label="卡类型" min-width="100"  :formatter="formatType" sortable>
			</el-table-column>
			
			<el-table-column prop="CreationTime" label="开卡时间" min-width="180" sortable>
			</el-table-column>
						<el-table-column prop="Height" label="身高cm" min-width="110" sortable>
			</el-table-column>
						<el-table-column prop="ArmLength" label="臂长cm" min-width="110" sortable>
			</el-table-column>
						<el-table-column prop="Weight" label="体重kg" min-width="110" sortable>
			</el-table-column>			

				<el-table-column prop="State" label="状态" min-width="90" :formatter="formatState" sortable>
			</el-table-column>
			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column>
			<el-table-column prop="Address" label="地址" min-width="200" sortable>
			</el-table-column>
			<!-- <el-table-column label="操作" width="200" fixed="right">
				<template  slot-scope="scope">
					<el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button type="primary" size="small" @click="ReplaceCard(scope.$index, scope.row)">换卡</el-button>
					<el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>

				</template>
			</el-table-column> -->
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-tag>当前有{{total}}位会员</el-tag>
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total" style="float:right;">
			</el-pagination>
		</el-col>






	</section>
</template>

<script>
	import util from '../../common/js/util'

	//import NProgress from 'nprogress'
	import {DataCompensation, getMemberListPage, removeUser, batchRemoveUser, editUser, addMember,getShopInfo,editMember ,getMemberCount,ReplaceCard,Reset,getShopInfor,Backups,BackupAll } from '../../api/api';

	export default {
		data() {
			return {
				filters: {
					Name: ''
				},
				backupsName:'',
				Telephone:'',
				CardNumber:'',
		        Shopoptions:[],
                shopId:'',
				Count:0,
				options:[],
				Members:[],
				total: 0,
				page: 0,
				listLoading: false,
				sels: [],//列表选中列
			}
			
		},
		methods: {
					//业务补偿
		DataCompensationClicik()
		{
			let para={}
            DataCompensation(para).then((res)=>{})
		},
		selectChange(event)
        { 
			
			this.page=0;
			
            this.Shopoptions.forEach(item => {
              if (item.Id==event) {
             this.backupsName=item.Name;
            //  console.log(this.introduction);
              }         
             })         
        },
		handBackups(){
			if(this.shopId=='')
			{
				this.$message({
					message: "请先选择门店",
					type: 'error'
				});
			}
			else
			{
		   let para={
			   TenancyId:this.shopId
		   }
		   Backups(para).then((res)=>{		
	   let blob = new Blob([res.data], {type: "application/vnd.ms-excel"});
	   var downloadElement = document.createElement('a');
var href = window.URL.createObjectURL(blob); //创建下载的链接
downloadElement.href = href;
downloadElement.download = this.backupsName; //下载后文件名
document.body.appendChild(downloadElement);
downloadElement.click(); //点击下载
document.body.removeChild(downloadElement); //下载完成移除元素
window.URL.revokeObjectURL(href); //释放掉blob对象
		   })
		   }
			},
		handBackupAll(){	
		   let para={
			   TenancyId:this.shopId
		   }
		   BackupAll(para).then((res)=>{		
	   let blob = new Blob([res.data], {type: "application/vnd.ms-excel"});
// application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
	   var downloadElement = document.createElement('a');
var href = window.URL.createObjectURL(blob); //创建下载的链接
downloadElement.href = href;
downloadElement.download = "所有系统会员"; //下载后文件名
document.body.appendChild(downloadElement);
downloadElement.click(); //点击下载
document.body.removeChild(downloadElement); //下载完成移除元素
window.URL.revokeObjectURL(href); //释放掉blob对象


		   })
			},
       getShopList()
        {
            let para={}
            getShopInfor(para).then((res) => {                  
                    this.Shopoptions = res.data;       
				})
				 .catch(error=>{
                 alert('网络错误');
                });          				
        },
			formatDate: function (row, column) {
				return util.formatDate.format(new Date(row.Birthday), 'yyyy-MM-dd');
			},
			formatState: function (row, column) {
				return row.State == 1 ? '暂停' : row.State == 0 ? '启用' : '未知';
			},
			//性别显示转换
			formatSex: function (row, column) {
				return row.Sex == 1 ? '男' : row.Sex == 0 ? '女' : '未知';
			},
			formatType: function (row, column) {
				return row.CardType == 0 ? '次卡' : row.CardType == 1 ? '月卡' : row.CardType == 2 ? '年卡': row.CardType == 3 ? '充值卡': row.CardType == 4 ? '培训卡': row.CardType==5?'业主卡':'未知';
			},
			handleCurrentChange(val) {
				this.page = val;
				this.getMember();
			},
			//获取用户列表
			getCount()
			{
              let para={                  
			  };
			  getMemberCount(para).then((res)=>{
				  this.Count=res.data.ExtendData;
			  }).catch(error=>{
                 alert('网络错误');
                });
			},
			selectClick()
			{
				this.total=0;
				this.getMember();
			},
			getMember() {
				// this.getCount();
				
				
				let para = {
					PageIndex: this.page-1,					
					PageSize:10,
					Name:this.filters.Name,
					TenancyId:this.shopId,
					IcCard:this.CardNumber,
					Telephone:this.Telephone,
				};
				this.listLoading = true;
				//NProgress.start();
				getMemberListPage(para).then((res) => {
					this.total = res.data.TotleCount;
					this.Members =res.data.Data;
                    // this.Count=res.data.TotleCount;
					this.listLoading = false;
				})
				 .catch(error=>{
                 alert('网络错误');
                });
			},
			//显示编辑界面
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editForm = Object.assign({}, row);
			},			
			selsChange: function (sels) {
				this.sels = sels;
			},
   closeDialog(){
      this.onCellClick(event);
    },
   onCellClick(event)
   {
      this.$nextTick(function(){
         this.$refs['siteInput'].focus();
          // this.$(event.target).children().find("input").focus();
      })
   },
		},
		mounted() {
			this.getMember();
			this.getShopList();
			// this.getCount();
		}
	}

</script>

<style scoped>
 /* .el-form-item {
    margin-bottom: 22px;
    height: 18px;
    } */
	.el-input__inner {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
	width: 300px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}
.input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}

</style>


// WEBPACK FOOTER //
// MemberList.vue?0a7d7931